const getLocationNumericFilters = (prefix, coords) => [
    `${prefix}.lat:${coords.minLat} TO ${coords.maxLat}`,
    `${prefix}.lng:${coords.minLng} TO ${coords.maxLng}`,
];

export { getLocationNumericFilters };
